module.exports = "/assets/site/images/empty.png?28a8266f082213072eebd97382acd2cd";